import { handleActions } from 'redux-actions';

import { NAMES as GET_CURRENT_SITE_USER } from 'widget/redux/server/actions/current-site-user/get';

export default handleActions(
  {
    [GET_CURRENT_SITE_USER.SUCCESS]: (state, { payload: { response } }) => {
      if (!response) {
        return null;
      }

      if (response.authResponse) {
        response = response.data;
      }

      return response;
    },
  },
  null,
);
